import { EstateType } from '~js/React/Enums';
import { EstateSelectorFallback } from './EstateSelectorFallback';

export const SearchFieldFallback = (): JSX.Element => {
  const filteredEstateTypes = Object.values(EstateType).filter(
    (type) => type !== EstateType.OwnedApartment && type !== EstateType.Premises
  );

  return (
    <div className="top-0 lg:top-[4rem] left-0 lg:sticky bg-white pt-3 lg:w-1/4 lg:min-w-[25.8rem] max-w-[25.8rem] h-full lg:max-h-[100vh] lg:overflow-y-auto no-scrollbar">
      <div className="animate-pulse">
        <div className="z-[10] bg-grey50 mr-3 pl-2 rounded-r-3xl h-12 lg:h-16"></div>
        <div className="justify-items-stretch gap-2 md:gap-3 grid grid-cols-4 md:grid-cols-7 lg:grid-cols-4 mt-4 mdplus:mb-4 px-3 overflow-hidden">
          {filteredEstateTypes?.map((type) => (
            <EstateSelectorFallback key={type} />
          ))}
        </div>
        <div className="bg-grey50 mx-auto mt-5 mb-3 px-8 py-1 rounded-md w-[11.875rem] h-8"></div>
      </div>
    </div>
  );
};
